import './import-bicycles.modal.scss';

export default function ImportBicyclesModal($scope, close, organisationId, groupId, bicycleOwnerId, onUpload,
                                            $file, $alert, $t, $gl) {
  'ngInject';

  $scope.importBicycles = {};

  $scope.chooseFile = (files, invalidFiles) => {
    if (!files || files.length === 0) {
      return;
    }

    const filesToImport = [];
    files.filter(file => $file.isValidCsvFile(file))
      .forEach(file => filesToImport.push(file));
    invalidFiles.filter(file => $file.isValidCsvFile(file))
      .forEach(file => filesToImport.push(file));
    if (filesToImport.length === 0) {
      return;
    }

    $scope.importBicycles.file = filesToImport[0];
  };

  $scope.import = () => {
    if (!$scope.importBicycles.file) {
      $alert.error($t('shared.modals.import_bicycles.select_file_error_message'));
    }

    const request = {
      file: $scope.importBicycles.file,
      organisationId: organisationId,
      groupId: groupId,
      bicycleOwnerId: bicycleOwnerId
    }

    $gl.show();

    onUpload(request,
      response => {
        $gl.hide();
        close(response);
      },
      error => {
        $gl.hide();
        $alert.processError(error, $t('shared.modals.import_bicycles.import_bicycles_error_message'))
      }
    );
  }

  $scope.close = () => {
    close(false);
  }
}